import makeStyles from '@mui/styles/makeStyles'

interface HamburgerMenuListItemStyleProps {
  selected: boolean
}

const useStyles = makeStyles<any, HamburgerMenuListItemStyleProps>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '15px 0px',
    color: ({ selected }) => selected && '#B64FCD',
    '& svg': {
      filter: ({ selected }) =>
        selected &&
        'invert(58%) sepia(80%) saturate(5283%) hue-rotate(261deg) brightness(87%) contrast(82%)'
    }
  },

  label: {
    paddingLeft: 20,
    fontSize: theme.size.base
  },

  dot: {
    position: 'absolute',
    top: '15px',
    left: ({ selected }) => (selected ? '37px' : '14px'),
    backgroundColor: '#EB5757',
    border: 'solid 1.5px white'
  }
}))

export default useStyles
